<template>
  <div>
    <div class="thank-you-container" style="direction: rtl">
      <p style="margin: 0px 0px 20px">איזה כיף שהזמנת את גוזו.</p>
      <p style="margin: 0px 0px 20px">
        הזמנתך התקבלה ואנחנו כבר מעבירים אותה לאריזה ומשלוח, טרם האספקה תקבלו הודעה מחברת
        המשלוחים על מועד האספקה.
      </p>
      <p style="margin: 0px 0px 20px">
        את הקבלה נשלח בדקות הקרובות לכתובת המייל שהזנת בעת הרכישה.
      </p>
      <p style="margin: 0px 0px 20px">
        עלתה לכם שאלה? מצוין! כתבו לנו ל<a href="mailto:guzo@ouisrael.org"
          >guzo@ouisrael.org
        </a>
        ואנו נדאג להשיב בהקדם.
      </p>
    </div>
  </div>
</template>
<style scoped>
.thank-you-container {
  padding: 20px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
  font-weight: 400;
  max-width: 900px;
  margin: 20px auto;
  text-align: center;
}
</style>
